import React, { useState } from "react";
import { Image } from "react-bootstrap";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import GeoLocation from "./GeoLoaction";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

const MapSetupScreenOne = (props) => {
  const onClickHandler = (condition) => async (e) => {
    let location = {};
    if (condition === "yes") {
      location = await GeoLocation(window.navigator);
    } else {
      try {
        let result = await axios.get("https://ipapi.co/json");
        location = {
          lat: result.data.latitude,
          lng: result.data.longitude,
        };
      } catch (err) {
        location = {
          lat: 18.67,
          lng: 29.67,
        };
      }
    }
    props.history.push({
      pathname: "/map-setup-two",
      state: { location: location, actionButton: true },
    });
  };
  const [formShow, setFormShow] = useState(false);
  const handleFormShow = () => {
    setFormShow(true);
  };
  const handleFormHide = () => {
    setFormShow(false);
  };
  return (
    <React.Fragment>
      <Media query="(max-width: 991px)">
        <>
          {!formShow && (
            <div className="bg-white min-height-100vh position-relative">
              <div className="mobileFirstScreen col-12">
                <SliderMobileReusableComponent
                  displayShow={true}
                  selectedProgressBarOne="active"
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-07.svg")}
                />
              </div>
              <div className="col-12 py-4">
                <div className="f24_700_HelveticaNeue">Map Set up</div>
                <div className="f16-400 opacity5">
                  Enter the details about your Business location
                </div>
              </div>
              <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                <ReusableOnboardingButton
                  buttonType="button"
                  buttonTitle="Next"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  buttonText="Next"
                  onClick={handleFormShow}
                />
              </div>
            </div>
          )}
        </>
      </Media>

      <div className={`container-fluid formShow ${formShow ? "active" : ""}`}>
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
          >
            {/* <div className="col-12 onboarding_process_screen_left-backbutton mb-md-5 mb-lg-5 mb-xl-5">
              {/* <NavLink to="/mapsetup" className="back_button-link">
                <Image
                  src={require("../../../../assets/images/Icon/onBoardBack.png")}
                  alt="Back Button"
                  title="Back Button"
                />
              </NavLink> *
            </div> */}
            <div className="col-12">
              <BackLogoIconButton
                displayBackText={false}
                displayArrow={false}
                backButtonClicked="/"
              />
            </div>
            <Media query="(max-width: 991px)">
              <MobileTopHeader onClick={handleFormHide} />
            </Media>
            <div className="onboarding_process_screen-left-mapinside">
              <div className="display-top">
                <TopTextReusableComponent
                  headingText="Map Setup"
                  headingParagraph="Enter the details about your Business location"
                />
              </div>
              <div className="onboarding-process-map-setup-bodyBox">
                {/* <div className="display-toggle-stepup-button">
                  <RightSidePannel selectedTab={1} />
                </div> */}
                <Media query="(max-width: 991px)">
                  <>
                    <div className="f24_700_HelveticaNeue">Map Set up</div>
                    <div className="f16-400">
                      Are you present on Google Maps?
                    </div>
                    <div className="fixed-bottom bg-white p-3 border-top d-flex justify-content-center">
                      <ReusableOnboardingButton
                        buttonType="button"
                        buttonTitle="No Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                        buttonText="No"
                        onClick={onClickHandler("no")}
                      />
                      <ReusableOnboardingButton
                        buttonType="button"
                        buttonTitle="Yes Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Yes"
                        onClick={onClickHandler("yes")}
                      />
                    </div>
                  </>
                </Media>
                <Media query="(min-width: 992px)">
                  <>
                    <div className="font_24_b">
                      Are you present on Google Maps?
                    </div>
                    <div className="onboarding-process-map-setup-buttonBox">
                      <ReusableOnboardingButton
                        buttonType="button"
                        buttonTitle="No Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                        buttonText="No"
                        onClick={onClickHandler("no")}
                      />
                      <ReusableOnboardingButton
                        buttonType="button"
                        buttonTitle="Yes Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Yes"
                        onClick={onClickHandler("yes")}
                      />
                    </div>
                  </>
                </Media>
              </div>
            </div>
          </div>
          {/* <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 onboarding_process_screen_right">
            <RightSidePannel
              selectedTab={1}
              headingText="Store Setup"
              imageSrc={require("../../../../assets/images/onboarding/storeSetup.svg")}
              paragraph="Enter information diligently about your food establishment. Users
            would like to know about your restaurant listed on our app. Take your
            time and fill information carefully"
            />
          </div> */}
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              displayBarButton={true}
              displayHamburger={true}
              selectedProgressBarOne="active"
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-07.svg")}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(MapSetupScreenOne);
